import * as types from '../mutation-types'
import billingService from '../../services/billings'
import _ from 'lodash'

const state = {
    loading: false,
    errors: null,
    billings: [],
    cls_billSums:[]
}

const actions = {
    async getAll({ commit }) {
        commit(types.BILLING_LOADING, true)
       await billingService.getAll().then(
            response => {

                commit(types.LOAD_BILLINGS, response.data)
                commit(types.BILLING_LOADING, false)
                commit(types.BILLING_FAILURE, null)
            },
            error => {
                commit(types.BILLING_FAILURE, error)
                commit(types.BILLING_LOADING, false)
            }
        )
    },
    add({ commit }, data) {
        commit(types.BILLING_LOADING, true)
        commit(types.BILLING_FAILURE, null)
        billingService.add(data).then(
            response => {
                //data.id = response.data.id
                //commit(types.ADD_BILLING, data)
                commit(types.BILLING_LOADING, false)

            },
            error => {
                commit(types.BILLING_FAILURE, error)
                commit(types.BILLING_LOADING, false)
            }
        )
    },
    update({ commit }, data) {
        commit(types.BILLING_LOADING, true)
        commit(types.BILLING_FAILURE, null)
        billingService.update(data.bill)
            .then(
                response => {
                    //console.log("updated responsooooo", response)
                    data.bill = response.data
                    //console.log(data)
                    commit(types.UPDATE_BILLING, data)
                    commit(types.BILLING_LOADING, false)

                },
                error => {
                    commit(types.BILLING_FAILURE, error)
                    commit(types.BILLING_LOADING, false)
                }
            )


    },

}

const mutations = {
    [types.ADD_BILLING](state, payload) {
        state.billings.unshift(payload);
    },
    [types.LOAD_BILLINGS](state, payload) {
        state.billings = payload

        state.cls_billSums = payload.map(x => {
          
            //console.log("lodasssh",ts);
          
        //   return { //old
        //     cid: x.id,
        //     cbsum: x.feestr?
        //       parseFloat(x.feestr.basic_amt) +
        //       x.feestr.adcharges.reduce((sum, val) => {
        //         return parseFloat(sum) + parseFloat(val.amount);
        //       }, 0):0
        //   };

        return {
            cid: x.id,
            cbsum: x.feestr ?
                parseFloat(x.feestr.basic_amt) +
                _.sumBy(
                    x.feestr.adcharges.filter(s => !s.charge_item.includes('optional')), //sum all class bill except optional adcharges
                    s => parseFloat(s.amount)
                ) : 0
        };
        });



    },
    [types.UPDATE_BILLING](state, payload) {
        Object.assign(state.billings[payload.index], payload.bill);
    },
    [types.BILLING_FAILURE](state, payload) {
        state.errors = payload
    },

    [types.BILLING_LOADING](state, payload) {
        state.loading = payload
    },
}


const getters = {
    BILLINGS: state => {
        return state.billings
    },

    C_BILL_SUMS: state => {
      return state.cls_billSums
  },

    BILLING_ERROR: state => {
        return state.errors
    },

    BILLING_LOADING: state => {
        return state.loading
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/billings.js